/** @format */

import {
	Directive,
	ElementRef,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	Output,
	PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
	selector: '[insideViewport]'
})
export class InsideViewportDirective implements OnChanges {
	@Input() insideViewport = false;
	@Output() isElementVisible = new EventEmitter<boolean>(true);

	constructor(
		private el: ElementRef<HTMLElement>,
		@Inject(PLATFORM_ID) private platformId
	) {}

	ngOnChanges(): void {
		if (isPlatformBrowser(this.platformId) && this.insideViewport) {
			this.isElementInView();
		}
	}

	isElementInView(): void {
		const elementHeight = this.el.nativeElement.offsetHeight;
		const parentElement = this.el.nativeElement.offsetParent?.getBoundingClientRect();
		if (parentElement?.top > 0 && parentElement?.top > elementHeight) {
			this.isElementVisible.emit(true);
		} else {
			this.isElementVisible.emit(false);
		}
	}
}
